<template>
  <form id="frm_action">
    <h5>THÔNG TIN CHUNG</h5>
    <div class="p-formgrid">
      <div class="">
        <div v-if="mode=='edit'" class="mt-3">
          <label class="txt-right required">Trạng thái</label>
          <Dropdown :disabled="getDisable()" v-model="status" :options="status_list" optionValue="value" optionLabel="label" class="text-box m-0"/>
        </div>
        <div class="" v-if="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN">
          <label class="txt-right required">Công ty</label>
          <DropdownScrollable cusClass="text-box m-0" :loading="loading" width="100%" :show="$store.getters.type == $constants.TYPE_USER.SUPPER_ADMIN" v-model="company" :options="items" :total="total" @keyup="emitEvent" @offset="changeOffset" :disabled="mode=='edit'" placeholder="Chọn"/>
          <input class="input_tmp_validator" id="company" />
        </div>
        <div class="mt-3">
          <label class="txt-right required">Phiếu đánh giá</label>
          <DropdownScrollable placeholder="Chọn" cusClass="text-box m-0" width="100%" v-model="evaluation_form" :options="evaluation_obj.items" :limit="evaluation_obj.limit" :loading="evaluation_obj.loading" :total="evaluation_obj.total" @keyup="emitEventEvaluation" @offset="changeOffsetEvaluation" @scroll="emitEventEvaluation"/>
          <input class="input_tmp_validator" id="evaluation_form_id" />
        </div>
        <div class="mt-3">
          <label class="txt-right required">Tình huống</label>
          <DropdownScrollable placeholder="Chọn" cusClass="text-box m-0" width="100%" v-model="situation" defaultValue="evaluation_form_danger_id" :options="situation_obj.items" :limit="situation_obj.limit" :loading="situation_obj.loading" :total="situation_obj.total" @keyup="emitEventSituation" @offset="changeOffsetSituation" @scroll="emitEventSituation"/>
          <input class="input_tmp_validator" id="situation" />
        </div>
        <div class="mt-3">
          <label class="txt-right required">Mối nguy</label>
          <DropdownScrollable placeholder="Chọn" cusClass="text-box m-0" width="100%" v-model="danger" defaultValue="evaluation_form_danger_id" :options="danger_obj.items" :limit="danger_obj.limit" :loading="danger_obj.loading" :total="danger_obj.total" @keyup="emitEventDanger" @offset="changeOffsetDanger" @scroll="emitEventDanger"/>
          <input class="input_tmp_validator" id="danger" />
        </div>
        
        <div class="mt-3">
          <label class="txt-right">THÔNG TIN BIỆN PHÁP</label>
        </div>
        <div class="mt-0">
          <label class="txt-right required">Tên biện pháp</label>
          <InputText
            v-model="name"
            type="text"
            class="text-box input-text-box"
            placeholder="Nhập"
          />
          <input class="input_tmp_validator" id="name" />
        </div>
        <div class="mt-3">
          <label class="txt-right required">Mô tả</label>
          <Textarea
            v-model="description"
            type="text"
            rows="2"
            class="text-box input-text-box"
            placeholder="Nhập"
          />
          <input class="input_tmp_validator" id="description" />
        </div>
        <div v-if="mode=='add'" class="mt-3">
          <label class="txt-right required">Loại biện pháp</label>
          <div class="d-flex align-items-center mt-0">
            <div style="float:left;width: 100px;">
              <RadioButton inputId="type1" name="type" value="TIME" v-model="type" />
              <span for="type1" class="mb-0" style="padding-left: 2px;">Có thời hạn</span>
            </div>
            <div style="float:right">
              <RadioButton inputId="type2" name="type" value="LOOP" v-model="type" />
              <span for="type2" class="mb-0" style="padding-left: 2px;">Lặp lại</span>
            </div>
          </div>
        </div>
        <div v-else class="mt-3">
          <label class="txt-right required">Loại biện pháp</label>
          <Dropdown disabled v-model="type" :options="type_list" optionValue="type" optionLabel="value" class="text-box m-0"/>
        </div>

        <form id="frm_action_loop" v-if="type=='LOOP'">
          <div class="mt-3">
            <label class="txt-right">Người thực hiện</label>
            <DropdownScrollable
              placeholder="Chọn"
              :showClear="false"
              cusClass="text-box m-0"
              width="100%"
              :multiple="false"
              :limit="implementer_obj.limit"
              :loading="implementer_obj.loading"
              v-model="implementer"
              :options="implementer_obj.items"
              :total="implementer_obj.total"
              onlyClick
              @scroll="emitEventImplementer"
              @offset="changeOffsetImplementer"
            />
            <input class="input_tmp_validator" id="implementer" />
          </div>
          <div class="mt-3">
            <label class="txt-right required">Tần suất lặp lại</label>
            <DropdownScrollable placeholder="Chọn" :showClear="false" cusClass="text-box m-0" width="100%" v-model="frequency" :options="frequency_list"/>
            <input class="input_tmp_validator" id="frequency" />
          </div>
          <div class="mt-3">
            <label class="txt-right">Người kiểm tra</label>
            <DropdownScrollable
              placeholder="Chọn"
              :showClear="false"
              cusClass="text-box m-0"
              width="100%"
              :multiple="false"
              :limit="checker_obj.limit"
              :loading="checker_obj.loading"
              v-model="checkers_sel"
              :options="checker_obj.items"
              :total="checker_obj.total"
              @keyup="emitEventChecker"
              @scroll="emitEventChecker"
              @offset="changeOffsetChecker"
            />
            <input class="input_tmp_validator" id="checkers" />
          </div>
          <div class="mt-3">
            <label v-for="(item, index) in checkers" :key="index" class="cus-tags">
              <span class="cs-tag">
                {{item.name}}
              </span>
              <i class="fas fa-times cs-icon" v-on:click="removeCheckers(index)"></i>
            </label>
          </div>
        </form>
        <div v-if="project && project.id">
          <div class="mt-3">
            <label class="txt-right">Dự án</label>
            <InputText disabled
              v-model="project.name"
              type="text"
              class="text-box input-text-box"
            />
          </div>
          <div class="mt-3">
            <label class="txt-right">Thời gian dự án</label>
            <Calendar disabled
              v-model="date_start_end"
              selectionMode="range"
              dateFormat="dd/mm/yy" 
              appendTo="body"
              :showIcon="true"
              :manualInput="false"
              class="text-box input-text-box"
            />
          </div>
        </div>
        
      </div>

      <Toolbar class="fixed-bottom-toolbar">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>
    </div>
  </form>
</template>

<script>
import DropdownScrollable from '@/components/DropdownScrollable.vue';
import ApiRepository from "@/core/ApiRepository";

export default {
  components:{
    DropdownScrollable
  },
  props: {
    mode: String,
    model: Object,
    users: Array,
    defaultData:Object,
  },
  data() {
    return {
      type : "TIME",
      company_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      evaluation_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      situation_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      type_list : [{type: "TIME",value : "Có thời hạn"},{type: "LOOP",value : "Lặp lại"}],
      filters: {},
      name: "",
      description : "",
      active: false,
      company: null,
      items: [],
      total: 0,
      loading: false,
      offset: 0,
      is_load_data : false,
      evaluation_form : null,
      situation : null,
      danger_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      danger : null,
      frequency_list : [{id : "WEEK", name: "Mỗi tuần"},{id : "MONTH", name: "Mỗi tháng"},{id : "QUATER_YEAR", name: "Mỗi 3 tháng"},{id : "HALF_YEAR", name: "Mỗi 6 tháng"},{id : "YEAR", name: "Mỗi năm"}],
      frequency : {id : "WEEK", name: "Mỗi tuần"},
      implementer : null,
      implementer_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      checker_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      checkers : [],
      status_list_default : {
        time : {
          WAITING : [
            {label: "Đề xuất",value: "WAITING"},
            {label: "Đã duyệt",value: "APPROVE"},
            {label: "Không duyệt",value: "NOT_APPROVE"},
          ],
          APPROVE : [{label: "Đã duyệt",value: "APPROVE"}],
          NOT_APPROVE : [{label: "Không duyệt",value: "NOT_APPROVE"}],
          PROJECT : [
            {label: "Mới",value: "NEW"},
            {label: "Đang thực hiện",value: "INPROCESS"},
            {label: "Tạm hoãn",value: "PENDING"},
            {label: "Kết thúc",value: "DONE"},
          ]
        },
        loop : {
          WAITING : [
            {label: "Đề xuất",value: "WAITING"},
            {label: "Đã duyệt",value: "APPROVE"},
            {label: "Không duyệt",value: "NOT_APPROVE"},
            {label: "Đã hủy",value: "CANCEL"}
          ],
          APPROVE : [{label: "Đã duyệt",value: "APPROVE"}],
          NOT_APPROVE : [{label: "Không duyệt",value: "NOT_APPROVE"}],
          CANCEL : [{label: "Đã hủy",value: "CANCEL"}]
        }
      },
      status_list : [],
      status : null,
      project : null,
      date_start_end : null,
      efd_id : null,
      checkers_sel : null,
    };
  },
  async mounted() {
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.is_load_data = true
      this.company_obj = {
        offset: 0,
        filters: {},
        limit: 0,
        items: [this.model.company],
        total: 1,
        loading: false
      }
      this.company = this.model.company;
      this.type = this.model.type
      if(this.model.type == 'TIME'){
        if(this.model.project_evaluation_measures && this.model.project_evaluation_measures.project_id){
          this.status = this.model.status_project
          this.status_list = this.status_list_default.time.PROJECT
          this.project = this.model.project_evaluation_measures.project
          this.date_start_end = [new Date(this.project.date_start), new Date(this.project.date_end)]
        }else{
          this.status = this.model.status
          this.status_list = this.status_list_default.time[this.model.status]
        }
      }else{
        this.status = this.model.status
        this.status_list = this.status_list_default.loop[this.model.status]
      }
      
      this.evaluation_form = this.model.evaluation_form;
      this.situation = this.model.situation;
      this.danger = this.model.danger;
      this.name = this.model.name;
      this.description = this.model.description;
      this.type = this.model.type;
      await this.getListEvaluation()
      await this.getListSituation()
      await this.getListDanger()
      if(this.model.type == 'LOOP'){
        if(this.model.uid_implementer){
          this.implementer = {id : this.model.uid_implementer , fullname : this.model.implementer_fullname, name : this.model.implementer_fullname}
        }
        if(this.model.control_measures_checker){
          var tmp_checkers = []
          for (let i = 0; i < this.model.control_measures_checker.length; i++) {
            const e= this.model.control_measures_checker[i];
            tmp_checkers.push({id : e.uid,fullname : e.fullname,name : e.fullname})
          }
          this.checkers = tmp_checkers
        }
        await this.getListImplementer()
        await this.getListChecker()
      }
      this.is_load_data = false
    }else{
      // await this.getListCompany();
      this.is_load_data = true
      if(!this.$commonFuction.isEmpty(this.defaultData) && !this.$commonFuction.isEmptyObject(this.defaultData)){
        console.log("defaultData",this.defaultData)
        this.company = this.defaultData.company
        this.evaluation_form = this.defaultData.evaluation_form;
        this.situation = this.defaultData.situation;
        this.danger = this.defaultData.danger;
        await this.getListEvaluation()
        await this.getListSituation()
        await this.getListDanger()
        this.is_load_data = false
      }else{
        if (this.$store.getters.type !== this.$constants.TYPE_USER.SUPPER_ADMIN) {
          this.company = {id : this.$store.getters?.company_id}
        }
        this.is_load_data = false
      }
    }
  },
  watch: {
    async "company"() {
      this.checkers_sel = null
      if(this.is_load_data == false){
        await this.clearChangeCompany();
        await this.getListEvaluation();
        await this.clearFormLoop();
        if(this.type=="LOOP"){
          await this.getListImplementer();
          await this.getListChecker()
        }else{
          this.frequency = {id : "WEEK", name: "Mỗi tuần"}
        }
      }
    },
    async "evaluation_form"() {
      if(this.is_load_data == false){
        await this.clearChangeEvaluation();
        await this.getListSituation();
      }
    },
    async "situation"() {
      if(this.is_load_data == false){
        await this.clearDanger();
        await this.getListDanger();
      }
    },
    async "type"() {
      if(this.is_load_data == false){
        await this.clearFormLoop();
        if(this.type=="LOOP"){
          await this.getListImplementer();
          await this.getListChecker()
        }else{
          this.frequency = {id : "WEEK", name: "Mỗi tuần"}
        }
      }
    },
    async "checkers_sel"() {
      if(this.$commonFuction.isEmptyObject(this.checkers_sel)){
        return
      }else{
        var check_exist = false;
        for (let i = 0; i < this.checkers.length; i++) {
          if(this.checkers[i].id == this.checkers_sel.id){
            check_exist = true;
            break;
          }
        }
        if(check_exist == false){
          this.checkers.push(this.checkers_sel)
        }
        this.checkers_sel = null
      }
    }, 
  },
  methods: {
    backToList() {
      this.$emit("back");
    },
    async emitEvent(keyword) {
      this.$delete(this.company_obj.filters, 'name');
      if (keyword) {
        this.company_obj.filters.name = keyword;
      }
      await this.getListCompany();
    },
    async changeOffset(value) {
      this.company_obj.offset = value;
      // await this.getListCompany();
    },
    async getListCompany() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        this.loading = true;
        await ApiRepository.post("/_api/company/options", {filters: this.filters, limit: 20, offset: this.offset}, {headers}).then((res) => {
          if (this.offset > 0) {
            this.items.push(...res.data.data.company);
          } else {
            this.items = res.data.data.company;
          }
          this.total = res.data.data.total;
          this.loading = false;
        }).catch((err) => {
            console.log(err);
            this.loading = false;
        })
      }
    },
    async validateData() {
      this.validationErrors = {};
      if (this.$store.getters.type == this.$constants.TYPE_USER.SUPPER_ADMIN) {
        let company_add = document.getElementById("company");
        if (
          this.$commonFuction.isEmptyObject(this.company) ||
          this.$commonFuction.isEmpty(this.company)
        ) {
          company_add.setCustomValidity("Công ty không được để trống!");
        } else {
          company_add.setCustomValidity("");
        }
      }
      let evaluation_form_add = document.getElementById("evaluation_form_id");
      if (
        this.$commonFuction.isEmptyObject(this.evaluation_form) ||
        this.$commonFuction.isEmpty(this.evaluation_form)
      ) {
        evaluation_form_add.setCustomValidity("Phiếu đánh giá không được để trống!");
      } else {
        evaluation_form_add.setCustomValidity("");
      }

      let situation_add = document.getElementById("situation");
      if (
        this.$commonFuction.isEmptyObject(this.situation) ||
        this.$commonFuction.isEmpty(this.situation)
      ) {
        situation_add.setCustomValidity("Tình huống không được để trống!");
      } else {
        situation_add.setCustomValidity("");
      }
      let danger_add = document.getElementById("danger");
      if (
        this.$commonFuction.isEmptyObject(this.danger) ||
        this.$commonFuction.isEmpty(this.danger)
      ) {
        danger_add.setCustomValidity("Mối nguy không được để trống!");
      } else {
        danger_add.setCustomValidity("");
      }

      let name_add = document.getElementById("name");
      this.name = this.name.trim();
      if ( this.name == undefined || this.name == null || this.name == "") {
        name_add.setCustomValidity("Tên biện pháp không được để trống!");
      } else if (this.name.length > 255) {
        name_add.setCustomValidity("Tên biện pháp không được quá 255 ký tự!");
      } else {
        name_add.setCustomValidity("");
      }
      this.description = this.description.trim();
      let description_add = document.getElementById("description");
      if ( this.description == undefined || this.description == null || this.description == "") {
        description_add.setCustomValidity("Mô tả không được để trống!");
      } else if (this.description.length > 14000) {
        description_add.setCustomValidity("Mô tả không được quá 14000 ký tự!");
      } else {
        description_add.setCustomValidity("");
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    async validateDataLoop() {
      let frequency_add = document.getElementById("frequency");
      if (
        this.$commonFuction.isEmptyObject(this.frequency) ||
        this.$commonFuction.isEmpty(this.frequency)
      ) {
        frequency_add.setCustomValidity("Tần suất lặp lại không được để trống!");
      } else {
        frequency_add.setCustomValidity("");
      }

      var inpObj = document.getElementById("frm_action_loop");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      if(this.type == 'LOOP'){
        if (await this.validateDataLoop()) {
          this.$commonFuction.is_loading(false);
          return;
        }
      }
      if (Object.entries(this.validationErrors).length !== 0) {
        this.$commonFuction.is_loading(false);
      }

      var params = {
        name: this.name,
        description: this.description,
        company: this.company,
        evaluation_form : this.evaluation_form,
        danger : this.danger,
        situation : this.situation,
        type : this.type,
        implementer : this.implementer,
        checkers : this.checkers,
        frequency : this.frequency,
        status : this.status,
        project : this.project,
      };
      // console.log("saveData", params);
      // this.$commonFuction.is_loading(false);
      this.$emit("save", params);

    },
    async emitEventEvaluation(keyword) {
      this.$delete(this.evaluation_obj.filters, 'name');
      if (keyword) {
        this.evaluation_obj.filters.name = keyword;
      }
      await this.getListEvaluation();
    },
    async changeOffsetEvaluation(value) {
      this.evaluation_obj.offset = value;
      // await this.getListEvaluation();
    },
    async getListEvaluation(){
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        this.evaluation_obj.loading = true;
        await ApiRepository.post("/_api/evaluation_form/options", {filters: this.evaluation_obj.filters, limit: 20, offset: this.evaluation_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
          if (this.offset > 0) {
            this.evaluation_obj.items.push(...res.data.data.list);
          } else {
            this.evaluation_obj.items = res.data.data.list;
          }
          this.evaluation_obj.total = res.data.data.total;
          this.evaluation_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.evaluation_obj.loading = false;
        })
      }
    },

    async emitEventSituation(keyword) {
      this.$delete(this.situation_obj.filters, 'name');
      if (keyword) {
        this.situation_obj.filters.name = keyword;
      }
      await this.getListSituation();
    },
    async changeOffsetSituation(value) {
      this.situation_obj.offset = value;
      // await this.getListSituation();
    },
    async getListSituation(){
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      if (this.$commonFuction.isEmptyObject(this.evaluation_form)) {
        return;
      }
      this.situation_obj.filters.evaluation_form_id = this.evaluation_form.id
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        this.situation_obj.loading = true;
        await ApiRepository.post("/_api/evaluation_form_danger/options_situation", {filters: this.situation_obj.filters, limit: 20, offset: this.situation_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
          if (this.offset > 0) {
            this.situation_obj.items.push(...res.data.data.list);
          } else {
            this.situation_obj.items = res.data.data.list;
          }
          this.situation_obj.total = res.data.data.total;
          this.situation_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.situation_obj.loading = false;
        })
      }
    },
    async emitEventDanger(keyword) {
      this.$delete(this.danger_obj.filters, 'name');
      if (keyword) {
        this.danger_obj.filters.name = keyword;
      }
      await this.getListDanger();
    },
    async changeOffsetDanger(value) {
      this.danger_obj.offset = value;
      // await this.getListDanger();
    },
    async getListDanger(){
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      if (this.$commonFuction.isEmptyObject(this.evaluation_form)) {
        return;
      }
      if (this.$commonFuction.isEmptyObject(this.situation)) {
        return;
      }
      this.danger_obj.filters.evaluation_form_id = this.evaluation_form.id
      this.danger_obj.filters.situation_id = this.situation.id
      if(this.situation.situation_type == 'other'){
        this.danger_obj.filters.evaluation_form_danger_id = this.situation.evaluation_form_danger_id
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        this.danger_obj.loading = true;
        await ApiRepository.post("/_api/evaluation_form_danger/options_danger", {filters: this.danger_obj.filters, limit: 20, offset: this.danger_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
          if (this.offset > 0) {
            this.danger_obj.items.push(...res.data.data.list);
          } else {
            this.danger_obj.items = res.data.data.list;
          }
          this.danger_obj.total = res.data.data.total;
          this.danger_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.danger_obj.loading = false;
        })
      }
    },
    emitEventImplementer(keyword) {
      console.log(keyword);
      this.getListImplementer();
    },
    changeOffsetImplementer(value) {
      this.implementer_obj.offset = value;
    },
    async getListImplementer() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.implementer_obj.loading = true;
        await ApiRepository.post("/_api/users/options", {filters: this.implementer_obj.filters, limit: this.implementer_obj.limit, offset: this.implementer_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            var tmp = res.data.data?.list
            for (let i = 0; i < tmp.length; i++) {
              tmp[i].name = tmp[i].fullname 
            }
            if (this.implementer_obj.offset > 0 ) {
              this.implementer_obj.items.push(...tmp);
            } else{
              this.implementer_obj.items = tmp;
            }
            
            this.implementer_obj.total = res.data.data.count;
            this.implementer_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.implementer_obj.loading = false;
        })
      }
    },
    emitEventChecker(keyword) {
      // console.log(keyword);
      this.$delete(this.checker_obj.filters, 'name');
      if (keyword) {
        this.checker_obj.filters.name = keyword;
      }
      this.getListChecker();
    },
    changeOffsetChecker(value) {
      this.checker_obj.offset = value;
    },
    async getListChecker() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        this.checker_obj.loading = true;
        await ApiRepository.post("/_api/users/options", {filters: this.checker_obj.filters, limit: this.checker_obj.limit, offset: this.checker_obj.offset, company_id: this.company.id}, {headers}).then((res) => {
            var tmp = res.data.data?.list
            for (let i = 0; i < tmp.length; i++) {
              tmp[i].name = tmp[i].fullname 
            }
            if (this.checker_obj.offset > 0 ) {
              this.checker_obj.items.push(...tmp);
            } else{
              this.checker_obj.items = tmp;
            }
            
            this.checker_obj.total = res.data.data.count;
            this.checker_obj.loading = false;
        }).catch((err) => {
            console.log(err);
            this.checker_obj.loading = false;
        })
      }
    },
    async clearChangeCompany(){
      this.clearEvaluation()
      // console.log("clear dữ liệu")
    },
    async clearChangeEvaluation(){
      this.clearSituation()
    },
    clearSituation(){
      this.situation_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.situation = null
    },
    clearEvaluation(){
      this.evaluation_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.evaluation_form = null
    },
    clearDanger(){
      this.danger_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.danger = null
    },
    clearFormLoop(){
      this.clearImplementer();
      this.clearChecker();
    },
    clearImplementer(){
      this.implementer_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.implementer = null
    },
    clearChecker(){
      this.checker_obj = {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      }
      this.checkers = []
    },
    getDisable(){
      if(this.project && this.project.id){
        return true;
      }
      return false;
    },
    removeCheckers(index){
      this.checkers.splice(index, 1);
    }
  },
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 80px;
  height: 80px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.p-checkbox {
  margin-right: 1rem !important;
}
.cus-tags{
  border-radius: 10px;
  padding: 8px;
  margin-right: 8px;
  background-color:#F2F3F7;
}
.cs-tag {
  padding: 10px 12px 10px 0px;
  font-weight: normal;
}
.cs-icon {
  color : #666666;
  padding-right: 4px;
  cursor: pointer;
}
</style>
